import { createApi } from '@reduxjs/toolkit/query/react';
import { DateRangeReq } from '~weekly-planner/types/api';

import { apiWeeklyPlanner } from '~constants/api';

import { Request, rtkBaseQueryWrapper, unwrap, WithRefetchKey } from '~libs/axiosWrapper';
import { Client } from '~weekly-planner/lib/common';

export const typePrefix = 'weekly-planner-clients';

type ClientsRequest = DateRangeReq &
  WithRefetchKey &
  Request & {
    disabled?: boolean;
  };

export const clientsApi = createApi({
  reducerPath: 'weeklyPlannerClientsApi',
  baseQuery: rtkBaseQueryWrapper({ baseUrl: apiWeeklyPlanner }),
  tagTypes: ['clients'],
  endpoints: (builder) => ({
    getClients: builder.query<Client[], ClientsRequest>({
      query: (arg) => {
        const { __refetchKey, ...rest } = (arg ?? {}) as ClientsRequest;
        const params = { disabled: false, limit: 0, ...rest };
        return { url: '/clients', method: 'GET', params };
      },
      serializeQueryArgs: ({ endpointName, queryArgs }) => {
        const { __refetchKey, ...stable } = queryArgs ?? {};
        return { endpointName, ...stable };
      },
      forceRefetch({ currentArg, previousArg }) {
        return currentArg?.__refetchKey !== previousArg?.__refetchKey;
      },
      providesTags: [{ type: 'clients', id: 'LIST' }],
      transformResponse: (payload) => unwrap<Client[]>(payload),
    }),
  }),
});

export const { useGetClientsQuery } = clientsApi;
